import React, {useContext, useEffect} from 'react';
import './VippsPaymentFrame.less';
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {PaymentStatuses} from "new-constants/common.constants";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const VIPPS_PAYMENT_FRAME_POPUP = 'VIPPS_PAYMENT_FRAME_POPUP';

export const VippsPaymentFrame = ({url, onPaymentSuccess, onPaymentError, onOverlayClick}) => {

	function onMessagePosted(e) {
		if (!e) return;
		if (typeof e.data !== 'string') return;
		if (!e.origin.includes('snappo.com') && !e.origin.includes('weorder.com') && !e.origin.includes('localhost')) return;
		if (!(e.data.includes('messages') && e.data.includes('status'))) return;

		let serverResponse = JSON.parse(e.data);

		if (serverResponse.status === PaymentStatuses.complete) {
			onPaymentSuccess();
		} else if (
			serverResponse.status === PaymentStatuses.cancelled ||
			serverResponse.status === PaymentStatuses.error
		) {
			onPaymentError(serverResponse.messages?.join('\n'));
		}
	}

	useEffect(() => {
		window.addEventListener('message', onMessagePosted, false);

		return () => {
			window.removeEventListener('message', onMessagePosted, false);
		}
	}, []);

	const translations = useContext(TranslationsContext);


	return <PseudoPagePopup
		title={getSafeTranslation('VippsPaymentFramePopup.title', translations)}
		onBackClick={onOverlayClick}
	>
		<iframe
			className="vipps-payment-frame"
			src={url}
			height="100%"
			width="100%"
			frameBorder="0"
		/>
	</PseudoPagePopup>
}
